import React from "react";
import { connect, shallowEqual, useSelector } from "react-redux";
import * as categoryRedux from "modules/Category/_redux/categoryRedux";
import { FLOOR_ORDER } from "helpers/floorOrder";
import "./sahibindenFilters.css";

// Bulunduğu kat aralığı: sıralı enum'da from-to seçimi.
// selectedFilter.minMaxBulunduguKat = [fromIdx, toIdx] (ordinal index).
// backend plugin'i seller bulunduguKatIdx üzerinde { $gte, $lte } uygular.
function SLBulunduguKatRange(props) {
  const { selectedFilter } = useSelector(
    (state) => ({ selectedFilter: state.category.selectedFilter }),
    shallowEqual
  );

  const value = selectedFilter?.minMaxBulunduguKat || ["", ""];
  const [min, max] = value;

  const setRange = (nextMin, nextMax) => {
    const empty =
      (nextMin === "" || nextMin === null || nextMin === undefined) &&
      (nextMax === "" || nextMax === null || nextMax === undefined);
    if (empty) {
      props.removeFilter({ parent: "minMaxBulunduguKat" });
      return;
    }
    props.addFilterBulk({
      parent: "minMaxBulunduguKat",
      value: [nextMin, nextMax],
    });
  };

  const parse = (v) => (v === "" ? "" : Number(v));

  return (
    <section id={props.filter.id} className="sf-section">
      <div className="sf-title">{props.filter.title || "Bulunduğu Kat"}</div>
      <div className="sf-minmax">
        <select
          className="sf-input"
          value={min == null ? "" : min}
          onChange={(e) => setRange(parse(e.target.value), max)}
        >
          <option value="">En alt</option>
          {FLOOR_ORDER.map((label, idx) => (
            <option key={label} value={idx}>
              {label}
            </option>
          ))}
        </select>
        <span className="sf-dash">–</span>
        <select
          className="sf-input"
          value={max == null ? "" : max}
          onChange={(e) => setRange(min, parse(e.target.value))}
        >
          <option value="">En üst</option>
          {FLOOR_ORDER.map((label, idx) => (
            <option key={label} value={idx}>
              {label}
            </option>
          ))}
        </select>
      </div>
    </section>
  );
}

export default connect(null, { ...categoryRedux.actions })(SLBulunduguKatRange);
